import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { loadWidgetCMP, setPreviewStatus } from '../actions';
import _ from 'lodash';
import WDPContext from '../../../../widgets/components/core/WDPContext';
var hash = require('object-hash');
class WidgetPreview extends React.Component {
    state = { height: 0 };

    render = () => {
        const {
            user,
            widgetId,
            template,
            widgetProps = {},
            zoom = 1.0,
            widgetCMP,
            onMeasure,
            setPreviewStatus,
        } = this.props;
        if (!widgetId) {
            return <div />;
        }
        const CMP = widgetCMP && _.get(window, `[rlz${widgetId}][${widgetId}]`);

        // return <>;
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: this.state.height || 'auto',
                    zoom,
                    '-moz-transform': `scale(${zoom},${zoom})`,
                    '-webkit-transform': `scale(${zoom},${zoom})`,
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {CMP && (
                    <WDPContext
                        client={user.client}
                        user={user.username}
                        token={user.accessToken}
                        key={widgetId + '_' + widgetProps.template + '_' + widgetProps.variation}
                        {...widgetProps}
                        template={widgetProps.template || template}
                    >
                        <CMP
                            name={widgetId}
                            {...widgetProps}
                            onMeasure={(width, height) => {
                                console.log('ON MEASURE', height);
                                // if (height !== 0 && height !== this.state.height) this.setState({ height });
                                if (onMeasure) onMeasure({ width, height });
                            }}
                            onError={e => {
                                setPreviewStatus(false, e);
                            }}
                            onOk={() => {
                                setPreviewStatus(true);
                            }}
                        />
                    </WDPContext>
                )}
            </div>
        );
    };
}

const mapStateToProps = ({ user, editor }, { widgetId }) => {
    const widgetCMP = editor.cmps.indexOf(widgetId + '') !== -1;

    return {
        user,
        widgetCMP,
    };
};

const mapDispatchToProps = { loadWidgetCMP, setPreviewStatus };

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    lifecycle({
        componentWillReceiveProps(nextProps) {
            if (nextProps.widgetId !== this.props.widgetId) {
                this.props.loadWidgetCMP(nextProps.widgetId);
            }
        },
        componentDidMount() {
            this.props.loadWidgetCMP(this.props.widgetId);
        },
    }),
)(WidgetPreview);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetEmbed.js
 **/